var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "new_user_top", staticStyle: { background: "#FFFFFF" } },
    [
      _c(
        "div",
        { staticClass: "nut" },
        [
          _c(
            "div",
            { staticClass: "nut_logo" },
            [
              _c("router-link", { attrs: { to: "/" } }, [
                _c("img", {
                  attrs: {
                    src: require("../assets/img/shiyan_logo.jpg"),
                    title: "欢迎访问进入个人学习中心！"
                  }
                })
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "nut_user" }, [
            _c("div", { staticClass: "nutu_user" }, [
              _vm._v(_vm._s(_vm.userInfo.realName) + "\n        "),
              _c("div", { staticClass: "nutuu_disk" }, [
                _c("div", { staticClass: "nutuud_top" }, [
                  _c("div", { staticClass: "nutuud_top_left" }, [
                    _c("img", { attrs: { src: _vm.userInfo.imageUrl } })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "nutuud_top_right" }, [
                    _c("p", [_vm._v(_vm._s(_vm.userInfo.realName))]),
                    _vm._v(" "),
                    _c(
                      "p",
                      { attrs: { title: _vm.userInfo.company.companyName } },
                      [_vm._v(_vm._s(_vm.userInfo.company.companyName))]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "nutuud_fastlink" },
                  [
                    _c(
                      "router-link",
                      {
                        attrs: {
                          to: {
                            path: "/EditUser",
                            query: { baseVisible: true }
                          }
                        }
                      },
                      [_vm._v("帐号设置")]
                    ),
                    _vm._v(" "),
                    _c(
                      "router-link",
                      {
                        attrs: {
                          to: { path: "/EditUser", query: { pwdVisible: true } }
                        }
                      },
                      [_vm._v("修改密码")]
                    )
                  ],
                  1
                )
              ])
            ]),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "nutu_bind",
                attrs: { href: "javascript:" },
                on: {
                  click: function($event) {
                    _vm.showLearnCardBind = true
                  }
                }
              },
              [_vm._v("绑定学习卡")]
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "nutu_exit",
                attrs: { href: "javascript:" },
                on: { click: _vm.logout }
              },
              [_vm._v("退出")]
            )
          ]),
          _vm._v(" "),
          _c("learnCardBind", {
            attrs: { value: _vm.showLearnCardBind },
            on: {
              "update:value": function($event) {
                _vm.showLearnCardBind = $event
              }
            }
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4c10e374", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c10e374","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header3.vue
// module id = null
// module chunks = 